exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".google_slides_addon_not_supported_route__wrapper--3Mazl {\n\twidth: 100vw;\n\theight: 100vh;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "google_slides_addon_not_supported_route__wrapper--3Mazl"
};